<div [ngClass]="{'card':!noCard}">
  <div [ngClass]="{'card-body':!noCard}">
    <div class="row">
      <div class="col mt-0">
        <h5 class="card-title">Session Notes</h5>
      </div>
      <div class="col-auto">
        <div class="col-green">
          <i class="fas fa-tasks pull-left card-icon col-orange font-30"></i>
        </div>
      </div>
    </div>

    <div class="row d-flex justify-content-center">
      <div class="w-150">
        <div class="col-auto ">
          <ul class="list-group list-group-flush">
            <ng-container *ngIf="bookings">
              <li class="list-group-item" *ngFor="let booking of bookings">
                <div class="row">

                  <div class="col-md-4 col-lg-4 col-sm-6">
                    <h5>{{booking.studentName}}</h5>
                  </div>
                  <div class="col-md-4 col-lg-4 col-sm-4">
                    {{booking.startDateTime|date: 'MMM d, yyyy @h:mm a'}}

                  </div>
                  <ng-container *ngIf="instructorId">
                    <div div class="col-md-4 col-lg-4 col-sm-2">
                      <button *ngIf="!booking.notes || booking?.notes?.length == 0" mat-stroked-button color="primary"
                        (click)="logNotes(booking)">Add
                        Notes</button>
                      <button *ngIf="booking?.notes?.length >0" mat-stroked-button color="primary"
                        (click)="logNotes(booking)">Update
                        Notes</button>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="studentId ">
                    <div class="col-md-4 col-lg-4 col-sm-4">
                      <button mat-stroked-button color="primary" (click)="viewNotes(booking)">View
                        Notes</button>
                    </div>
                  </ng-container>
                </div>
              </li>
            </ng-container>

          </ul>
        </div>
      </div>
    </div>
  </div>
